<template>
  <v-card
    class="ma-0 mb-4 mt-1"
    :class="{ 'pricing-mobile': isMobileView }"
    width="100%"
    flat
  >
    <!-- Desktop -->
    <template v-if="!isMobileView">
    <v-app-bar
      flat
      class="my-0 py-1"
      dense
      height="30"
    >
      <v-chip-group>
        <v-chip
          label
          outlined
          color="red"
        >
          {{ $t('firstCost') }} : {{ (costs ? $numberFormat(costs.first) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="pink"
        >
          {{ $t('minCost') }} : {{ (costs ? $numberFormat(costs.min) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="green"
        >
          {{ $t('averageCost') }} : {{ (costs ? $numberFormat(costs.average) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="purple"
        >
          {{ $t('maxCost') }} : {{ (costs ? $numberFormat(costs.max) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
        <v-chip
          label
          outlined
          color="deep-purple"
        >
          {{ $t('lastCost') }} : {{ (costs ? $numberFormat(costs.last) + ' ' + $store.state.currency.name : '') }}
        </v-chip>
      </v-chip-group>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f2']"
            v-bind="attrs"
            icon
            small
            class="mx-1"
            @shortkey="addRow()"
            v-on="on"
            @click="addRow()"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('newRow') }} (f2)</span>
      </v-tooltip>
    </v-app-bar>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row class="mx-0 my-2" />
      <v-col
        cols="12"
        class="px-2 py-0 "
      >
        <v-data-table
          v-if="headers"
            v-model="selected"
        :height="tableHeight"
        fixed-header
          :headers="headers"
          :items="items"
          :options.sync="tableOptions"
          :server-items-length="totalItems"
          :loading="loading"
          multi-sort
          dense
          :show-select="showSelect"
          hide-default-footer
          item-key="id"
        >
          <template v-slot:item.actions="{ item }">
            <v-menu
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  icon
                  v-on="on"
                >
                  <v-icon
                    medium
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  @click="openDeleteDialog(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="pink">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('remove')" />
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.row="{ item }">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </template>
          <template v-slot:item.product="{ item }">
            <autocomplete
              :ref="'refProduct' + parseInt(items.indexOf(item))"
              v-model="item.product"
              :value="item.product"
              class="mb-3"
              :rules="[v => !!v || $t('is-required')]"
              type="product"
              :disabled="!entrepot"
              :data="JSON.stringify({entrepot:(entrepot ? entrepot.id : null)})"
              :new-btn="true"
              @input="checkProduct(item.product, parseInt(items.indexOf(item)))"
            />
          </template>
          <template v-slot:item.type="{ item }">
            <v-select
              v-model="item.type"
              :items="typeItems"
              height="30"
              dense
              outlined
              class="mb-3"
              item-value="value"
              item-text="text"
              @change="changetype(item)"
            />
          </template>
          <template v-slot:item.name="{ item }">
            <v-text-field
              v-model="item.name"
              height="20"
              dense
              solo
              flat
              :rules="[v => !!v || $t('is-required')]"
              class="mb-3 dense"
              clearable
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('name')"
            />
          </template>
          <template v-slot:item.category="{ item }">
            <autocomplete
              v-model="item.category"
              :label="$t('account-category')"
              type="accountCategory"
              class="mb-3"
              :set-init="false"
              :value="item.category"
            />
          </template>
          <template v-slot:item.currency="{ item }">
            <autocomplete
              ref="refCategory"
              v-model="item.currency"
              :label="$t('account-category')"
              type="currency"
              class="mb-3"
              :set-init="true"
              :value="item.currency"
            />
          </template>
          <template v-slot:item.min="{ item }">
            <v-text-field
              v-model="item.min"
              height="20"
              dense
              solo
              flat
              class="mb-3 dense"
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('count')"
              type="number"
            />
          </template>
          <template v-slot:item.branch="{ item }">
            <aicomplete
              v-model="item.branch"
              title="branch"
              type="branch"
              class="mb-3"
              :set-init="false"
              :val="item.branch"
              :new-btn="true"
            />
          </template>
          <template v-slot:item.max="{ item }">
            <v-text-field
              v-model="item.max"
              height="20"
              dense
              solo
              flat
              class="mb-3 dense"
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('count')"
              type="number"
            />
          </template>
          <template v-slot:item.woocommerce="{ item }">
            <div>
              <v-checkbox
                v-model="item.woocommerce"
                class="mx-4 ma-0 mb-3"
                style="height: 20px"
                value="active"
              />
            </div>
          </template>
          <template v-slot:item.percent="{ item }">
            <v-text-field
              v-model="item.percent"
              height="20"
              dense
              solo
              flat
              class="mb-3 dense"
              clearable
              :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
              :placeholder="$t('percent')"
              type="number"
              @keyup="calPrice(item)"
            />
          </template>
          <template v-slot:item.price="{ item }">
            <money
              v-model="item.price"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              class="mb-3 dense"
              @input="onkeyPrice(item)"
            />
          </template>
        </v-data-table>
      </v-col>
      <v-divider class="mx-2" />
      <v-card-actions class="pt-0" />
      <v-row />
    </v-form>
    </template>

    <!-- Mobile composer UI -->
    <div
      v-else
      class="pricing-mobile__body"
      dir="rtl"
    >
      <div class="pricing-mobile__costs">
        <div class="pricing-mobile__cost">
          {{ $t('firstCost') }}: {{ costText('first') }}
        </div>
        <div class="pricing-mobile__cost">
          {{ $t('minCost') }}: {{ costText('min') }}
        </div>
        <div class="pricing-mobile__cost">
          {{ $t('averageCost') }}: {{ costText('average') }}
        </div>
        <div class="pricing-mobile__cost">
          {{ $t('maxCost') }}: {{ costText('max') }}
        </div>
        <div class="pricing-mobile__cost">
          {{ $t('lastCost') }}: {{ costText('last') }}
        </div>
      </div>

      <button
        type="button"
        class="pricing-mobile__add"
        @click="addRow"
      >
        <v-icon size="18" color="#5A6B85">mdi-plus</v-icon>
        <span>{{ $t('newRow') }}</span>
      </button>

      <div
        v-if="!items || !items.length"
        class="pricing-mobile__empty"
      >
        هنوز ردیفی اضافه نشده است.
      </div>

      <div
        v-for="(item, i) in items"
        :key="'price-m-' + i"
        class="pricing-mobile__card"
        :class="{ 'pricing-mobile__card--open': mobileOpenIndex === i }"
      >
        <div
          class="pricing-mobile__card-top"
          role="button"
          tabindex="0"
          @click="toggleMobileRow(i)"
          @keydown.enter.prevent="toggleMobileRow(i)"
          @keydown.space.prevent="toggleMobileRow(i)"
        >
          <div class="pricing-mobile__card-head">
            <v-icon
              size="20"
              color="#78909C"
              class="pricing-mobile__card-chevron"
            >
              {{ mobileOpenIndex === i ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
            <div class="pricing-mobile__card-titles">
              <span class="pricing-mobile__card-title">
                {{ $t('row') }} {{ i + 1 }}
              </span>
              <span class="pricing-mobile__card-summary">
                {{ mobileRowSummary(item) }}
              </span>
            </div>
          </div>
          <button
            type="button"
            class="pricing-mobile__remove"
            :aria-label="$t('remove')"
            @click.stop="openDeleteDialog(item)"
          >
            <v-icon size="20" color="#E91E63">mdi-trash-can-outline</v-icon>
          </button>
        </div>

        <div
          v-show="mobileOpenIndex === i"
          class="pricing-mobile__card-body"
        >
          <div class="pricing-mobile__field">
            <div class="pricing-mobile__label">{{ $t('type') }}</div>
            <v-select
              v-model="item.type"
              :items="typeItems"
              item-value="value"
              item-text="text"
              solo
              flat
              dense
              hide-details
              height="40"
              append-icon="mdi-chevron-down"
              class="pricing-mobile__select"
              @change="changetype(item)"
            />
          </div>

          <div class="pricing-mobile__field">
            <div class="pricing-mobile__label">{{ $t('name') }}</div>
            <input
              v-model="item.name"
              type="text"
              class="pricing-mobile__input"
              :placeholder="$t('name')"
              autocomplete="off"
            >
          </div>

          <div class="pricing-mobile__field">
            <div class="pricing-mobile__label">{{ $t('account-category') }}</div>
            <autocomplete
              v-model="item.category"
              title=""
              type="accountCategory"
              :set-init="false"
              :value="item.category"
              class="pricing-mobile__picker"
            />
          </div>

          <div class="pricing-mobile__field">
            <div class="pricing-mobile__label">{{ $t('branch') }}</div>
            <aicomplete
              v-model="item.branch"
              title="branch"
              type="branch"
              :set-init="false"
              :val="item.branch"
              :new-btn="true"
              class="pricing-mobile__picker"
            />
          </div>

          <div class="pricing-mobile__field">
            <div class="pricing-mobile__label">{{ $t('currency') }}</div>
            <autocomplete
              v-model="item.currency"
              title=""
              type="currency"
              :set-init="true"
              :value="item.currency"
              class="pricing-mobile__picker"
            />
          </div>

          <div class="pricing-mobile__row">
            <div class="pricing-mobile__field">
              <div class="pricing-mobile__label">{{ $t('min') }}</div>
              <button
                type="button"
                class="pricing-mobile__control pricing-mobile__control--numpad"
                @click="openNumpad(item, 'min', $t('min'), false)"
              >
                {{ hasValue(item.min) ? item.min : '—' }}
              </button>
            </div>
            <div class="pricing-mobile__field">
              <div class="pricing-mobile__label">{{ $t('max') }}</div>
              <button
                type="button"
                class="pricing-mobile__control pricing-mobile__control--numpad"
                @click="openNumpad(item, 'max', $t('max'), false)"
              >
                {{ hasValue(item.max) ? item.max : '—' }}
              </button>
            </div>
          </div>

          <div class="pricing-mobile__row">
            <div class="pricing-mobile__field">
              <div class="pricing-mobile__label">{{ $t('percent') }}</div>
              <button
                type="button"
                class="pricing-mobile__control pricing-mobile__control--numpad"
                @click="openNumpad(item, 'percent', $t('percent'), true)"
              >
                {{ hasValue(item.percent) ? item.percent : '—' }}
              </button>
            </div>
            <div class="pricing-mobile__field">
              <div class="pricing-mobile__label">{{ $t('price') }}</div>
              <button
                type="button"
                class="pricing-mobile__control pricing-mobile__control--numpad"
                @click="openNumpad(item, 'price', $t('price'), true)"
              >
                {{ formatMoney(item.price) }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Mobile numpad -->
    <v-bottom-sheet
      v-if="isMobileView"
      v-model="numpadOpen"
      @click:outside="numpadOpen = false"
    >
      <v-card
        class="pricing-numpad"
        dir="rtl"
      >
        <div class="pricing-numpad__header">
          <span class="pricing-numpad__spacer" />
          <div class="pricing-numpad__title">{{ numpadLabel }}</div>
          <button
            type="button"
            class="pricing-numpad__back"
            @click="numpadOpen = false"
          >
            <v-icon size="22">mdi-close</v-icon>
          </button>
        </div>
        <div class="pricing-numpad__display">
          <div class="pricing-numpad__display-label">{{ numpadLabel }}</div>
          <div class="pricing-numpad__display-value">{{ numpadDisplay }}</div>
        </div>
        <div
          class="pricing-numpad__pad"
          dir="ltr"
        >
          <div class="pricing-numpad__digits">
            <button
              v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]"
              :key="n"
              type="button"
              class="pricing-numpad__key"
              @click="numpadDigit(n)"
            >
              {{ n }}
            </button>
            <button
              type="button"
              class="pricing-numpad__key pricing-numpad__key--multi"
              @click="numpadAppend('00')"
            >
              00
            </button>
            <button
              type="button"
              class="pricing-numpad__key"
              @click="numpadDigit(0)"
            >
              0
            </button>
            <button
              type="button"
              class="pricing-numpad__key pricing-numpad__key--multi"
              @click="numpadAppend('000')"
            >
              000
            </button>
          </div>
          <div class="pricing-numpad__actions">
            <button
              type="button"
              class="pricing-numpad__key pricing-numpad__key--action"
              @click="numpadStep(1)"
            >
              +
            </button>
            <button
              type="button"
              class="pricing-numpad__key pricing-numpad__key--action"
              @click="numpadStep(-1)"
            >
              -
            </button>
            <button
              type="button"
              class="pricing-numpad__key pricing-numpad__key--action"
              @click="numpadClear"
            >
              C
            </button>
            <button
              type="button"
              class="pricing-numpad__key pricing-numpad__key--action"
              :disabled="!numpadIsAmount"
              @click="numpadDot"
            >
              .
            </button>
            <button
              type="button"
              class="pricing-numpad__key pricing-numpad__key--action"
              @click="numpadBackspace"
            >
              <v-icon size="20">mdi-backspace-outline</v-icon>
            </button>
          </div>
        </div>
        <div class="pricing-numpad__footer">
          <v-btn
            color="primary"
            block
            height="48"
            @click="confirmNumpad"
          >
            {{ $t('confirm') }}
          </v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>

    <!-- Desktop delete confirm -->
      <v-dialog
      v-if="!isMobileView"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Mobile delete confirm (same pattern as ProductListMobile) -->
    <v-bottom-sheet
      v-if="isMobileView"
      v-model="deleteSheet"
    >
      <v-card
        class="pricing-confirm-sheet"
        dir="rtl"
      >
        <div class="pricing-confirm-sheet__handle" />
        <div class="pricing-confirm-sheet__icon">
          <v-icon
            size="26"
            color="#E53935"
          >
            mdi-trash-can-outline
          </v-icon>
        </div>
        <div class="pricing-confirm-sheet__title">
          {{ $t('delete') }}
        </div>
        <p class="pricing-confirm-sheet__subtitle">
          {{ $t('are-you-sure-delete-this-case') }}
        </p>
        <div
          v-if="deleteItem"
          class="pricing-confirm-sheet__rows"
        >
          <div class="pricing-confirm-sheet__row">
            <span>{{ $t('row') }}</span>
            <strong>{{ deleteRowNumber }}</strong>
          </div>
          <div class="pricing-confirm-sheet__row">
            <span>{{ $t('type') }}</span>
            <strong>{{ mobileRowSummary(deleteItem) }}</strong>
          </div>
        </div>
        <div class="pricing-confirm-sheet__actions">
          <v-btn
            color="error"
            block
            depressed
            height="48"
            class="pricing-confirm-sheet__yes"
            @click="remove"
          >
            {{ $t('yes') }}
          </v-btn>
          <v-btn
            outlined
            block
            height="48"
            color="secondary"
            class="pricing-confirm-sheet__no"
            @click="cancelDelete"
          >
            {{ $t('no') }}
          </v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  export default {
    name: 'SellList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      aicomplete: () => import('../../components/general/AIcomplete/index'),
    },
    mixins: [General],
    props: {
      input: { default: null },
      formType: { default: null },
      value: { default: null },
      costs: { default: null },
      method: { default: null },
      mobile: { type: Boolean, default: false },
    },
    data: () => ({
      selected: [],
      printDialog: false,
      deletDialog: false,
      deleteSheet: false,
      showSelect: false,
      render: false,
      filter: false,
      valid: true,
      detail: null,
      recipientEntrepot: null,
      relations: null,
      productStatus: null,
      productStatusItems: null,
      date: null,
      entrepot: null,
      model: null,
      from: 1,
      taskDialog: null,
      id: null,
      status: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      typeForm: null,
      type: 'receipt',
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      headers: null,
      search: null,
      tableHeight: 400,
      typeItems: [],
      numpadOpen: false,
      numpadTarget: null,
      numpadField: null,
      numpadLabel: '',
      numpadDraft: '',
      numpadIsAmount: true,
      mobileOpenIndex: 0,
    }),
    computed: {
      isMobileView () {
        if (this.mobile) return true
        return !!(this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.mobile)
      },
      numpadDisplay () {
        const raw = String(this.numpadDraft ?? '').trim()
        if (!raw || raw === 'NaN' || Number.isNaN(Number(raw))) return '0'
        if (!this.numpadIsAmount || !this.$numberFormat) return raw
        try {
          const formatted = this.$numberFormat(raw)
          if (formatted == null || String(formatted) === 'NaN') return raw
          return formatted
        } catch (e) {
          return raw
        }
      },
      deleteRowNumber () {
        if (!this.deleteItem || !this.items) return '—'
        const idx = this.items.indexOf(this.deleteItem)
        return idx >= 0 ? idx + 1 : '—'
      },
    },
    watch: {
      value () {
      },
      items: {
        handler: function () {
          this.$emit('input', this.items)
        },
        deep: true,
      },
      refId () {
      },
      model () {
        this.$emit('input', this.model)
      },
      tableOptions: {
        handler () {
          var app = this
          app.sortBy = []
          app.tableOptions.sortBy.map(function (value) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      relations () {
        var app = this
        if (app.relations && app.relations.article) {
          app.items = []
          app.items = app.relations.article
          app.mobileOpenIndex = app.items.length ? 0 : -1
        } else {
          app.addRow()
        }
      },
    },
    beforeMount () {
      this.type = this.$route.name
      if (this.$route.params.id != null) {
        this.render = false
        this.id = this.$route.params.id
      } else {
        this.render = true
        this.addRow()
      }
    },
    mounted () {
      if (this.value) {
        this.items = this.value
        this.mobileOpenIndex = this.items && this.items.length ? 0 : -1
      }
      this.headers = [
        {
          text: '#',
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 40,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 40,
        },
        {
          text: this.$t('type'),
          sortable: false,
          value: 'type',
          width: 150,
        },
        {
          text: this.$t('name'),
          sortable: false,
          value: 'name',
          width: 150,
        },
        {
          text: this.$t('account-category'),
          sortable: false,
          value: 'category',
          width: 150,
        },
        {
          text: this.$t('branch'),
          sortable: false,
          value: 'branch',
          width: 150,
        },
        {
          text: this.$t('currency'),
          sortable: false,
          value: 'currency',
          width: 150,
        },
        {
          text: this.$t('min') + '(' + this.$t('count') + ')',
          sortable: false,
          value: 'min',
          width: 100,
        },
        {
          text: this.$t('max') + '(' + this.$t('count') + ')',
          sortable: false,
          value: 'max',
          width: 100,
        },
        {
          text: this.$t('percent'),
          sortable: false,
          value: 'percent',
          width: 150,
        },
        {
          text: this.$t('price'),
          sortable: false,
          value: 'price',
          width: 150,
        },
      ]
      this.typeItems = [
        {
          value: 'price',
          text: this.$t('sellPrice'),
        },
        {
          value: 'discount',
          text: this.$t('discount'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.loading = false
    },
    methods: {
      costText (key) {
        if (!this.costs || this.costs[key] == null || this.costs[key] === '') return '—'
        try {
          return this.$numberFormat(this.costs[key]) + ' ' + (this.$store.state.currency.name || '')
        } catch (e) {
          return String(this.costs[key])
        }
      },
      hasValue (v) {
        if (v === null || v === undefined || v === '') return false
        if (typeof v === 'number' && Number.isNaN(v)) return false
        if (String(v) === 'NaN') return false
        return true
      },
      formatMoney (v) {
        if (!this.hasValue(v)) return '—'
        if (this.$numberFormat) {
          try {
            const formatted = this.$numberFormat(v)
            if (formatted != null && String(formatted) !== 'NaN') return formatted
          } catch (e) { /* fallthrough */ }
        }
        return String(v)
      },
      changetype (item) {
        item.percent = null
        item.price = null
      },
      onkeyPrice (item) {
        item.percent = null
      },
      calPrice (item) {
        if (item.percent && item.type === 'price') {
          var profit = parseFloat(this.costs[this.method]) * (item.percent / 100)
          item.price = parseFloat(profit) + parseFloat(this.costs[this.method])
        }
      },
      addRow () {
        this.items.push({
          product: null,
          min: null,
          max: null,
          price: null,
          type: 'price',
          name: null,
          percent: null,
          branch: null,
          category: null,
          currency: null,
          woocommerce: null,
        })
        this.mobileOpenIndex = this.items.length - 1
      },
      remove () {
        var index = this.items.indexOf(this.deleteItem)
        if (index >= 0) this.items.splice(index, 1)
        this.deletDialog = false
        this.deleteSheet = false
        this.deleteItem = null
        if (!this.items.length) {
          this.mobileOpenIndex = -1
        } else if (this.mobileOpenIndex === index) {
          this.mobileOpenIndex = Math.min(index, this.items.length - 1)
        } else if (this.mobileOpenIndex > index) {
          this.mobileOpenIndex -= 1
        }
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        if (this.isMobileView) {
          this.deleteSheet = true
          this.deletDialog = false
        } else {
        this.deletDialog = true
          this.deleteSheet = false
        }
      },
      cancelDelete () {
        this.deletDialog = false
        this.deleteSheet = false
        this.deleteItem = null
      },
      toggleMobileRow (index) {
        this.mobileOpenIndex = this.mobileOpenIndex === index ? -1 : index
      },
      mobileRowSummary (item) {
        if (!item) return '—'
        const typeItem = (this.typeItems || []).find(t => t.value === item.type)
        const typeText = typeItem ? typeItem.text : (item.type || '—')
        let detail = ''
        if (item.name) {
          detail = String(item.name)
        } else if (this.hasValue(item.price)) {
          detail = this.formatMoney(item.price)
        } else if (this.hasValue(item.percent)) {
          detail = String(item.percent) + '%'
        }
        return detail ? (typeText + ' · ' + detail) : typeText
      },
      openNumpad (item, field, label, isAmount) {
        this.numpadTarget = item
        this.numpadField = field
        this.numpadLabel = label
        this.numpadIsAmount = !!isAmount
        const cur = item[field]
        this.numpadDraft = this.hasValue(cur) ? String(cur) : ''
        this.numpadOpen = true
      },
      numpadDigit (num) {
        this.numpadAppend(String(num))
      },
      numpadAppend (chunk) {
        const piece = String(chunk)
        if (!piece) return
        if (String(this.numpadDraft).length + piece.length > 16) return
        if (!this.numpadDraft && /^\d+$/.test(piece)) {
          this.numpadDraft = piece.replace(/^0+(?=\d)/, '')
        } else if (this.numpadDraft === '0' && /^\d+$/.test(piece)) {
          this.numpadDraft = piece
        } else {
          this.numpadDraft = String(this.numpadDraft) + piece
        }
      },
      numpadDot () {
        if (!this.numpadIsAmount) return
        if (!this.numpadDraft) {
          this.numpadDraft = '0.'
          return
        }
        if (String(this.numpadDraft).includes('.')) return
        this.numpadDraft = String(this.numpadDraft) + '.'
      },
      numpadBackspace () {
        const current = String(this.numpadDraft || '')
        this.numpadDraft = current.length <= 1 ? '' : current.slice(0, -1)
      },
      numpadClear () {
        this.numpadDraft = ''
      },
      numpadStep (delta) {
        const next = (parseFloat(this.numpadDraft) || 0) + delta
        this.numpadDraft = next < 0 ? '0' : String(next)
      },
      confirmNumpad () {
        if (this.numpadTarget && this.numpadField) {
          const raw = String(this.numpadDraft || '').trim()
          if (raw === '') {
            this.numpadTarget[this.numpadField] = null
          } else {
            const parsed = parseFloat(raw)
            this.numpadTarget[this.numpadField] = Number.isNaN(parsed) ? null : parsed
          }
          if (this.numpadField === 'percent') {
            this.calPrice(this.numpadTarget)
          } else if (this.numpadField === 'price') {
            this.onkeyPrice(this.numpadTarget)
          }
        }
        this.numpadTarget = null
        this.numpadField = null
        this.numpadOpen = false
      },
    },
  }
</script>

<style scoped>
.pricing-mobile {
  margin: 0 !important;
  background: transparent !important;
}
.pricing-mobile__body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 2px 8px;
}
.pricing-mobile__costs {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2px;
  scrollbar-width: none;
}
.pricing-mobile__costs::-webkit-scrollbar {
  display: none;
}
.pricing-mobile__cost {
  flex: 0 0 auto;
  padding: 6px 10px;
  border: 1px solid #e0e4e8;
  border-radius: 999px;
  background: #fff;
  font-size: 11px;
  font-weight: 700;
  color: #546e7a;
  white-space: nowrap;
}
.pricing-mobile__add {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 44px;
  border: 1px solid #c5d0e0;
  border-radius: 10px;
  background: #e8edf5;
  color: #5a6b85;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.pricing-mobile__add:active {
  background: #dde4ef;
}
.pricing-mobile__empty {
  padding: 16px;
  border: 1px dashed #cfd8dc;
  border-radius: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #90a4ae;
}
.pricing-mobile__card {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 10px 12px;
  border: 1px solid #e0e4e8;
  border-radius: 12px;
  background: #fff;
}
.pricing-mobile__card--open {
  padding-bottom: 12px;
}
.pricing-mobile__card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}
.pricing-mobile__card--open .pricing-mobile__card-top {
  padding-bottom: 10px;
  margin-bottom: 12px;
  border-bottom: 1px solid #eef2f5;
}
.pricing-mobile__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;
}
.pricing-mobile__card-chevron {
  flex: 0 0 auto;
}
.pricing-mobile__card-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.pricing-mobile__card-title {
  font-size: 12px;
  font-weight: 700;
  color: #78909c;
  line-height: 1.3;
}
.pricing-mobile__card-summary {
  font-size: 14px;
  font-weight: 700;
  color: #37474f;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pricing-mobile__card-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.pricing-mobile__remove {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f8bbd0;
  border-radius: 10px;
  background: #fce4ec;
  cursor: pointer;
}
.pricing-mobile__field {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  gap: 0;
}
.pricing-mobile__label {
  display: block;
  flex: 0 0 auto;
  margin: 0 2px 6px;
  font-size: 13px;
  font-weight: 600;
  color: #455a64;
  line-height: 1.4;
  text-align: right;
}
.pricing-mobile__input,
.pricing-mobile__control {
  width: 100%;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #cfd8dc;
  border-radius: 8px;
  background: #fff;
  color: #37474f;
  font-size: 15px;
  font-weight: 700;
  text-align: right;
  box-sizing: border-box;
}
.pricing-mobile__control {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
.pricing-mobile__control--numpad {
  justify-content: center;
  text-align: center;
}
.pricing-mobile__control:active {
  background: #e3f2fd;
  border-color: #90caf9;
}
.pricing-mobile__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.pricing-mobile__select {
  margin: 0 !important;
  width: 100%;
  height: 40px !important;
  max-height: 40px !important;
  overflow: hidden !important;
}
.pricing-mobile__select ::v-deep .v-input__control {
  min-height: 40px !important;
  height: 40px !important;
  margin: 0 !important;
}
.pricing-mobile__select ::v-deep .v-input__slot {
  min-height: 40px !important;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #cfd8dc !important;
  border-radius: 8px !important;
  background: #fff !important;
  box-shadow: none !important;
}
.pricing-mobile__select ::v-deep .v-input__slot::before,
.pricing-mobile__select ::v-deep .v-input__slot::after {
  display: none !important;
}
.pricing-mobile__select ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center !important;
}
/* Same reset as invoice-edit-field / ilm-f-field: outer label above,
   hide Vuetify floating label + outlined top padding so titles don't
   float onto the previous field. */
.pricing-mobile__picker {
  display: block;
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 40px;
  height: 40px !important;
  max-height: 40px !important;
  overflow: hidden !important;
}
.pricing-mobile__picker ::v-deep .v-input,
.pricing-mobile__picker ::v-deep .v-text-field,
.pricing-mobile__picker ::v-deep .v-autocomplete,
.pricing-mobile__picker ::v-deep .v-select {
  margin: 0 !important;
  margin-top: 0 !important;
  padding: 0 !important;
  padding-top: 0 !important;
  font-size: 15px;
}
.pricing-mobile__picker ::v-deep .v-input__control {
  min-height: 40px !important;
  height: 40px !important;
  margin: 0 !important;
}
.pricing-mobile__picker ::v-deep .v-input__slot {
  min-height: 40px !important;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 10px !important;
  border: 1px solid #cfd8dc !important;
  border-radius: 8px !important;
  background: #fff !important;
  box-shadow: none !important;
}
.pricing-mobile__picker ::v-deep fieldset {
  display: none !important;
}
.pricing-mobile__picker ::v-deep .v-input__slot::before,
.pricing-mobile__picker ::v-deep .v-input__slot::after {
  display: none !important;
}
.pricing-mobile__picker ::v-deep .v-label {
  display: none !important;
}
.pricing-mobile__picker ::v-deep .v-text-field__details,
.pricing-mobile__picker ::v-deep .v-messages {
  display: none !important;
  min-height: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.pricing-mobile__picker ::v-deep .v-input__append-inner,
.pricing-mobile__picker ::v-deep .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
}
.pricing-mobile__picker ::v-deep input,
.pricing-mobile__picker ::v-deep .v-select__selection {
  margin: 0 !important;
  font-size: 15px;
  font-weight: 700;
  color: #37474f;
}
.pricing-numpad {
  border-radius: 16px 16px 0 0 !important;
  overflow: hidden;
}
.pricing-numpad__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 0;
}
.pricing-numpad__title {
  font-size: 15px;
  font-weight: 700;
  color: #37474f;
}
.pricing-numpad__spacer,
.pricing-numpad__back {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
}
.pricing-numpad__display {
  margin: 8px 16px 12px;
  padding: 12px 14px;
  border: 1px solid #e0e6ed;
  border-radius: 12px;
  background: #f7f9fc;
  text-align: right;
}
.pricing-numpad__display-label {
  font-size: 12px;
  font-weight: 600;
  color: #78909c;
}
.pricing-numpad__display-value {
  margin-top: 4px;
  font-size: 22px;
  font-weight: 800;
  color: #263238;
}
.pricing-numpad__pad {
  display: grid;
  grid-template-columns: 1fr 72px;
  gap: 8px;
  padding: 0 12px 12px;
}
.pricing-numpad__digits {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.pricing-numpad__actions {
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  gap: 8px;
}
.pricing-numpad__key {
  min-height: 48px;
  border: 1px solid #cfd8dc;
  border-radius: 10px;
  background: #fff;
  font-size: 18px;
  font-weight: 700;
  color: #37474f;
  cursor: pointer;
}
.pricing-numpad__key:active {
  background: #eceff1;
}
.pricing-numpad__key--multi {
  font-size: 14px;
}
.pricing-numpad__key--action {
  background: #eef3f8;
}
.pricing-numpad__footer {
  padding: 0 12px calc(12px + env(safe-area-inset-bottom, 0px));
}
.pricing-confirm-sheet {
  border-radius: 20px 20px 0 0 !important;
  padding: 8px 16px calc(16px + env(safe-area-inset-bottom, 0px));
  background: #fff !important;
}
.pricing-confirm-sheet__handle {
  width: 40px;
  height: 4px;
  margin: 4px auto 14px;
  border-radius: 999px;
  background: #cfd8dc;
}
.pricing-confirm-sheet__icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: rgba(229, 57, 53, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pricing-confirm-sheet__title {
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  color: #212121;
  margin: 0 0 8px;
}
.pricing-confirm-sheet__subtitle {
  margin: 0 0 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
  line-height: 1.6;
}
.pricing-confirm-sheet__rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
}
.pricing-confirm-sheet__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f5f7f9;
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
}
.pricing-confirm-sheet__row strong {
  font-size: 14px;
  font-weight: 800;
  color: #263238;
  text-align: left;
}
.pricing-confirm-sheet__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.pricing-confirm-sheet__yes {
  border-radius: 12px !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
}
.pricing-confirm-sheet__no {
  border-radius: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}
</style>
